import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { data } from 'jquery';
import { Csp5080Service } from '../../CSPService/CSP5080/csp5080.service';
import { Csp5080Class } from '../../CSPClass/CSP5080/csp5080-class';
@Component({
  selector: 'kt-csp5080-view',
  templateUrl: './csp5080-view.component.html',
  styleUrls: ['./csp5080-view.component.scss']
})
export class Csp5080ViewComponent implements OnInit {

   lblPageTitle: string = "";
    HostelList: any[] = [];
  constructor(private router: Router,public dialogRef: MatDialogRef<Csp5080ViewComponent>, private objCsp5080Service:Csp5080Service,private changeDetectorRef: ChangeDetectorRef
  ) { }

  ngOnInit() {
        this.onGetDatas();
  }
 onGetDatas() {
   if (localStorage.getItem('currentUser') != null) {
              var userLoginDetails = JSON.parse(localStorage.getItem('currentUser'));
              var classobj = new Csp5080Class();
              classobj.UserNam= userLoginDetails.UserNam;
                this.objCsp5080Service.Hostel(classobj).subscribe((data) => {
                 this.HostelList = data || []; 
              });
              this.changeDetectorRef.detectChanges();
            }
          }
indianFormatter = new Intl.NumberFormat('en-IN', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
});

formatIN(value: number): string {
  const num = Number(value) || 0;
  return this.indianFormatter.format(num);
}


//Total Calculations for Hostel  Fee Tab

HostelFeeTotalAmountToPay(): number {
  return this.HostelList.reduce((sum, item) => {
    const value = Number(String(item.amount_topay).replace(/,/g, '')) || 0;
    return sum + value;
  }, 0);
}

HostelFeeTotalAmountPaid(): number {
  return this.HostelList.reduce((sum, item) => {
    const value = Number(String(item.amount_paid).replace(/,/g, '')) || 0;
    return sum + value;
  }, 0);
}

HostelFeeTotalAmountDue(): number {
  return this.HostelList.reduce((sum, item) => {
    const value = Number(String(item.amount_due).replace(/,/g, '')) || 0;
    return sum + value;
  }, 0);
}
//End of Total Calculations for Hostel Fee Tab

  onClose() {
  if (this.dialogRef) {
    this.dialogRef.close();
  }
}
   getComponentTitle() {
    let result =  "Hostel";
    return result;
   }
}

